import React, { useRef, useEffect } from 'react';

function VideoBackground({ scrollY }) {
  const videoRef = useRef(null);
  const videoTransform = `translateY(${scrollY * 0.3}px)`;

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1.0;
    }
  }, []);

  return (
    <div className="video-background" style={{ transform: videoTransform }}>
      <video 
        ref={videoRef}
        autoPlay 
        loop 
        muted 
        playsInline
        preload="auto"
      >
        <source src="/videos/sanrovideo.mp4" type="video/mp4" />
      </video>
      <div className="video-overlay"></div>
    </div>
  );
}

export default VideoBackground;
